import { useEffect, useRef, useState } from 'react';
import * as API from '../../framework/API/api'
import { ENTITYNAME } from '../../framework/constant/constant';
import moment from 'moment';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { useTranslation } from '../../locale/useTranslation';
import { utility } from '../../framework/utility/utilityProvider';
import { Loader } from '../../framework/forms/helpercomponents/Loader';
import SeriesGantView from './SeriesGantView';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';


const SeriesTimeLineView = (props) => {

    let selectedDate = props.selectedDate ?? new Date();
    let filterChannels = props.filterChannels ?? [];

    var showTitle = props.showTitle ?? true;
    var myTitle = props.title ?? "";
    const lang = useTranslation();

    const [dataItem, _setDataItem] = useState({});
    const dataItemRef = useRef({});
    const setDataItem = (data) => { 
        dataItemRef.current = data; 
        _setDataItem(data); 
    };

    const [data, setData] = useState({});
    const [channels, setChannels] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [timeSlots, setTimeSlots] = useState([]);
    const [slotDuration, setSlotDuration] = useState(60);
    const [selectedDay, setSelectedDay] = useState(30);
    const [selectedView, setSelectedView] = useState('week');

    useEffect(() => {
        loadcombo();
    }, []);

    const createTimeRanges = (intervalMinutes = 30) => {
        const slots = [];
        const totalMinutesInDay = 24 * 60;
        for (let mins = 0; mins < totalMinutesInDay; mins += intervalMinutes) {
            const hours = Math.floor(mins / 60).toString().padStart(2, '0');
            const minutes = (mins % 60).toString().padStart(2, '0');
            slots.push({ label: `${hours}:${minutes}`, minutesSinceMidnight: mins });
        }
        return slots;
    };

    const loadcombo = async () => {

        let channelRes = await API.getDataLookup(ENTITYNAME.Channel, { sort: { FullChannelName: 1 } });
        setChannels([ ...channelRes.data ]);

        setDataItem({ 
            StartDate: moment(new Date(selectedDate)).format("YYYY-MM-DD"),
            EndDate: moment(selectedDate).add(selectedDay, 'days').format('YYYY-MM-DD'),
            Channel: filterChannels.length > 0 ? filterChannels[0] : utility.getDefaultItem(channelRes.data) 
        });

        setTimeSlots(createTimeRanges(slotDuration));

        loadData();

    }

    const loadData = async () => {

        setIsLoading(true);

        var filterPayload = {
            "Channel": dataItemRef.current.Channel,
            "StartDate": new Date(dataItemRef.current.StartDate).getTime(),
            "EndDate": new Date(dataItemRef.current.EndDate).getTime(),
            "SearchText": ""
        }

        console.log(filterPayload);

        let res = await API.getSeriesTimeLineData(filterPayload);
        console.log(res)

        if (res.success) {

            //SORT DATA
            let sortedData = {};
            Object.keys(res.data).map((key) => {
                sortedData[key] = res.data[key].sort(function (a, b) {
                    return new Date(a.SlotDateTime) - new Date(b.SlotDateTime);
                });
            })

            setData(sortedData);
            setIsLoading(false);
        }
    }

    const onChange = (e) => {

        if(e.target.name == "StartDate"){

            props.onDateChange(new Date(e.target.value));

            setDataItem({ 
                ...dataItem,
                StartDate: e.target.value,
                EndDate: moment(e.target.value).add(selectedDay, 'days').format('YYYY-MM-DD'),
            })

        } else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
        
        loadData()
    }


    const CustomGanttView = (props) => {
        const { timelineViewData = {} } = props;

        if (timelineViewData.length === 0) return null;

        // Calculate min and max
        const startDateTime = new Date(dataItemRef.current.StartDate);
        const endDateTime = new Date(dataItemRef.current.EndDate);

        return (
            <SeriesGantView
                channel={dataItemRef.current.Channel}
                startDateTime={startDateTime}
                endDateTime={endDateTime}
                data={timelineViewData}
                timeSlots={props.timeSlots}
                setTimeSlots={props.setTimeSlots}
                slotDuration={props.slotDuration}
                selectedView={props.selectedView}
            />
        );

    };

    const onSlotDurationChange = (e) => {

        setSlotDuration(e.target.value);
        setTimeSlots(createTimeRanges((e.target.value)));
        loadData();

    }

    const onDaysChange = (e) => {

        setSelectedDay(e.target.value);

        setDataItem({ 
            ...dataItemRef.current,
            EndDate: moment(dataItemRef.current.StartDate).add(e.target.value, 'days').format('YYYY-MM-DD'),
        })

        loadData();

    }
    

    return (
        <>
            {showTitle && (
                <>
                    <h1 className="page-title txt-color-bludeDark">
                        <i className="fa fa-table marlr" style={{ fontSize: "20px", color: "GrayText" }}></i>
                        <span>{myTitle}</span>
                    </h1>
                </>
            )}
            <div className='row'>
                <div className='col-3' style={{ padding: '0px 0px 0px 30px' }}>
                    <label htmlFor="TabView">{lang.channel_label}</label><br />
                    <DropDownList
                        data={channels}
                        name="Channel"
                        textField="FullChannelName"
                        dataItemKey="SID"
                        value={dataItem.Channel}
                        onChange={onChange}
                    />
                </div>
                <div className="col-2" style={{ padding: '0px 0px 0px 15px' }}>
                    <div className="form-group">
                        <label htmlFor="">{lang.start_date_label}</label>
                        <input type="date" className="form-control form-control-sm" name="StartDate" value={dataItem.StartDate} onChange={onChange} />
                    </div>
                </div>

                <div className="col-2" style={{ padding: '0px 0px 0px 15px' }}>
                    <label htmlFor="">{lang.days_label}</label>
                    <DropDownList
                        data={[15,30,45,60,75,90]}
                        name="selectedDay"
                        value={selectedDay}
                        onChange={onDaysChange}
                    />
                </div>

                <div className="col-2" >
                    <label htmlFor="">{lang.slot_duration_label}</label>
                    <DropDownList
                        data={[15, 30, 60]}
                        name="slotDuration"
                        value={slotDuration}
                        onChange={onSlotDurationChange}
                    />
                </div>
                <div className="col text-right"  style={{ margin : "10px" }}>
                    <ToggleButtonGroup
                        color="primary"
                        value={selectedView}
                        exclusive
                        onChange={(e) => setSelectedView(e.target.value) }
                        aria-label="Platform"
                        style={{ height : '35px' }}
                    >
                        <ToggleButton value="week" style={{ fontSize:'13px' }}>Week</ToggleButton>
                        <ToggleButton value="day" style={{ fontSize:'13px' }}>Day</ToggleButton>
                    </ToggleButtonGroup>
                </div>
                
            </div>
            {isLoading ? <Loader /> : <CustomGanttView timelineViewData={data} dataItem={dataItem} timeSlots={timeSlots} setTimeSlots={setTimeSlots} slotDuration={slotDuration} selectedView={selectedView}/> }
        </>
    );
}


export default SeriesTimeLineView;